import React from 'react';
import Select from 'components/Select';
import PropTypes from 'prop-types';

const REASONS = [
  { value: 'COMP', label: 'Request COMP—does not meet requirement' },
  { value: 'SOLD', label: 'Hotel is Sold Out' },
  { value: 'RMTYPE', label: 'Must have specific room type' },
  { value: '2ND', label: 'Requesting 2nd Room' },
  { value: 'DNM', label: 'No COMP—does not meet requirement' }
];

function WaitlistReasonSelect({ id, value, onChange, onBlur, ...props }) {
  return (
    <Select
      id={id}
      className="noBorder"
      clearable={false}
      deleteRemoves={false}
      backspaceRemoves={false}
      placeholder={''}
      value={value}
      options={REASONS}
      onChange={onChange}
    />
  );
}

WaitlistReasonSelect.propTypes = {
  id: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

export default WaitlistReasonSelect;
